<template>
  <section class="other-courses">
    <div class="other-courses__wrapper ui-container">
      <h2
        class="other-courses__title h h--3"
      >
        Другие курсы от {{ title }}
      </h2>

      <div class="other-courses__list-wrapper">
        <ul class="other-courses__list">
          <li
            v-for="(card, i) in cards"
            :key="i"
            class="other-courses__item"
          >
            <ProductCardSmart
              v-if="card"
              :card="card"
              class="other-courses__card"
              @click="emits('click:card', getCardData(card, i))"
              @visible="emits('visible:card', getCardData(card, i))"
            />
          </li>
        </ul>
      </div>

      <UiButtonLink
        v-if="buttonLink"
        :link="buttonLink"
        size="extra-big"
        stretch-mode="md-max"
        theme="quaternary"
        class="other-courses__button"
      >
        {{ buttonText }}
      </UiButtonLink>
    </div>
  </section>
</template>

<script setup lang="ts">
  import UiButtonLink from '@academica-box/components/Links/UiButtonLink/UiButtonLink.vue'
  import type { Card } from '@academica-box/components/Cards/UiProductCard/types'

  defineProps<{
    title: string;
    cards: Card[];
    buttonLink?: string;
    buttonText?: string;
  }>()

  const emits = defineEmits([
    'click:card',
    'visible:card'
  ])

  const getCardData = (card: Card, index: number) => {
    return {
      ...card,
      nomenclatureType: card.isFree ? 'free' : 'paid',
      cardNumber: index + 1
    }
  }
</script>

<style lang="scss">
  @use '@academica-box/utils/styles/mixins/combinations/media-reset-z' as *;
  @use '@academica-box/styles/UiContainer/variables' as *;

  .other-courses__wrapper {
    @include media(lg) {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  .other-courses__title {
    margin-bottom: 32px;

    @include media(lg) {
      width: 713px;
      margin-right: auto;
    }
  }

  .other-courses__list-wrapper {
    position: relative;

    &::before {
      @include z-index(below);

      position: absolute;
      width: 100%;
      height: 100%;
      background-color: var(--bg-invert-color);
      opacity: 0.03;
      filter: blur(15px);
      content: "";
    }
  }

  .other-courses__list {
    @include ulres;

    display: flex;
    margin-right: -20px;
    margin-bottom: 32px;
    margin-left: -20px;
    padding-left: 20px;

    @include media(md, md-max) {
      margin-right: calc((100vw - #{$ui-md-c}) / -2);
      margin-left: calc((100vw - #{$ui-md-c}) / -2);
      padding-left: calc((100vw - #{$ui-md-c}) / 2);
    }

    @include media(md-max) {
      flex-wrap: nowrap;
      overflow-x: auto;
      -ms-overflow-style: none;
      scrollbar-width: none;
    }

    @include media(lg) {
      margin-right: auto;
    }

    // фикс для Сафари
    &::after {
      padding-right: 20px;

      @include media(md) {
        padding-right: 36px;
      }

      @include media(md-max) {
        content: '';
      }
    }

    &::-webkit-scrollbar {
      @include media(md-max) {
        display: none;
      }
    }
  }

  .other-courses__item {
    display: none;
    flex-shrink: 0;
    width: 260px;

    @include media(md-max) {
      display: block;
    }

    @include media(lg) {
      width: 288px;
    }

    @include media(xl) {
      width: 320px;
    }

    &:not(:last-child) {
      margin-right: 6px;

      @include media(lg) {
        margin-right: 32px;
      }
    }

    &:nth-child(-n + 3) {
      @include media(lg) {
        display: block;
      }
    }

    &:nth-child(-n + 4) {
      @include media(xxl) {
        display: block;
      }
    }
  }

  .other-courses__card {
    height: 100%;
  }
</style>
